import React from "react";
import "./styles/CompanyInfo.css";

const CompanyInfo = () => {
  return (
    <div className="companyInfo">
      <h2>Despre Companie</h2>
      <p>
        Suntem o companie de construcții cu o experiență vastă în domeniu,
        specializată în dezvoltarea de proiecte rezidențiale și comerciale.
        Misiunea noastră este să construim spații care îmbunătățesc calitatea
        vieții clienților noștri.
      </p>
    </div>
  );
};

export default CompanyInfo;
